import { useState } from "react";

import useDebounce from "./useDebounce";

interface Options {
  /**
   * Default value. Defaults to blank string `""`.
   */
  default?: string;

  /**
   * Wait time for debounce. Doesn't debounce by default.
   */
  debounce?: number;
}

type Return = [string, (text: string) => void];

/**
 * For search fields that search as you type. Don't set `value` prop of the
 * input component because that will delay your typing because the updater of
 * this state is debounced.
 */
export default function useSearchText(opts?: Options): Return {
  const [search, setSearch] = useState(opts?.default ?? "");

  const setSearchText = useDebounce(setSearch, opts?.debounce ?? 0);

  return [search, setSearchText];
}
